// extracted by mini-css-extract-plugin
module.exports = {"layout":"AppLayout_layout__1QCuh","sidebarAbierto":"AppLayout_sidebarAbierto__u_8r_"};